<template>
	<section class="device-verification-login-process">
		<CMultifactorInput
			ref="mfaInput"
			:is-validated="validated"
			:is-loading="loading"
			autofocus
			input-classes="mt-3"
			label="Please enter the code sent to your email address to verify this device."
			@complete="login"
		/>
		<div class="sz-2">
			<a class="text-center underline block" @click="resendVerificationEmail">
				Didn't receive the code? Resend now.
			</a>
			<a class="text-center underline block mt-2" @click="showSupportDialog = true">
				Can't get to your email?
			</a>
		</div>
		<Transition name="fade" :duration="100" mode="out-in">
			<CDialog :visible="showSupportDialog" :close-on-click-modal="false" title="Submit a Support Request" custom-class="support-widget__dialog dialog--medium" @close="closeSupportForm">
				<CForm id="91" ref="supportForm" :key="numberSubmitted" :prefill="prefillData" org="Ri6aAJ7sHkKfWelbeqMQkw" @after-submit="afterSubmit" />
			</CDialog>
		</Transition>
	</section>
</template>

<script>
	import notify from '@cognitoforms/shared-components/src/utilities/notify';
	import CForm from '@cognitoforms/shared-components/src/components/embeds/CognitoForm.vue';
	import CDialog from '@cognitoforms/shared-components/src/components/dialogs/Dialog.vue';
	import CMultifactorInput from 'src/components/form-controls/MultifactorInput.vue';
	import { authStore } from 'src/stores/auth-store';
	import { deviceVerificationLogin, resendVerificationCode } from '@cognitoforms/api/services/authentication';

	export default {
		components: {
			CMultifactorInput,
			CForm,
			CDialog
		},
		props: {
			rememberMe: { type: Boolean, default: false },
			inviteCode: { type: String, default: null },
			email: { type: String, default: null },
			organization: { type: String, default: null }
		},
		data() {
			return {
				loading: false,
				validated: false,
				verificationCode: '',
				socialStatus: 'default',
				authStore,
				showSupportDialog: false,
				numberSubmitted: 0,
				prefillData: {}
			};
		},
		mounted() {
			this.prefillData = {
				'User': {
					'Email': 'Enter an email address you have access to.',
					'Organization': this.organization
				},
				'RequestType': 'report a problem',
				'ProblemSummary': 'Cannot verify device',
				'ProblemDescription': 'I cannot access the inbox for the email address associated with my Cognito Forms account. This email is '
					+ this.email + '.'
			};
		},
		methods: {
			login(code) {
				this.loading = true;
				this.socialStatus = 'validating';
				deviceVerificationLogin(
					this.authStore.deviceVerification.token,
					code,
					this.rememberMe,
					this.inviteCode,
					this.verificationCode
				).then(res => {
					if (res.Succeeded) {
						this.validated = true;
						this.loading = false;
						window.location.assign(res.ReturnUrl);
					}
					else if (res.MfaToken) {
						this.authStore.mfa.multifactorToken = res.MfaToken;
						this.authStore.mfa.backupEmail = res.MfaBackupEmail;
						this.authStore.mfa.encryptedAuthMethod = res.EncryptedAuthMethod;
					}
					else if (res.RedirectUri) {
						window.location.assign(res.RedirectUri);
					}
					else {
						this.loading = false;
						this.validated = false;
					}
				}).catch((error) => {
					this.loading = false;
					this.validated = false;

					if (error.statusCode === 429) {
						this.authStore.deviceVerification.token = null;
					}
				});
			},
			resendVerificationEmail() {
				resendVerificationCode(this.authStore.deviceVerification.token).then(() => {
					notify('We\'re sending you another code now.', 'success');
					// set focus on the mfa input field
					this.$refs.mfaInput.$el.querySelector('input').focus();
				}).catch(() => {
					notify('An error has occurred.', 'error');
				});
			},
			closeSupportForm() {
				this.showSupportDialog = false;

				if (this.submitted) {
					this.numberSubmitted++;
					this.submitted = false;
				}
			},
			afterSubmit() {
				this.submitted = true;
				this.closeSupportForm();
			}
		}
	};
</script>